// extracted by mini-css-extract-plugin
export default {"svg":"FlagIcon_svg__K1g7R"};